import type { I18n } from 'vue-i18n'
import type { LanguageType } from '@/constants/language'
import { defineStore } from 'pinia'
import { getCookieLanguageType } from '@/utils/cookies'

interface LanguageState {
    language: LanguageType
    i18n: any
}

const languageStore = defineStore('LANGUAGE_STORE', {
    state: (): LanguageState => ({
        language: getCookieLanguageType(),
        i18n: {},
    }),
    actions: {
        setI18nInstance(instance: I18n) {
            this.i18n = instance.global
        },
        t(key: string, variable?: { [key: string]: string }) {
            return this.i18n.t(key, variable)
        },
    },
})

export const useLanguageStore = () => languageStore()
